import Component from "vue-class-component";
import { VueBase } from "../../Controls/VueBase";
import { DeclarationOethDto } from "../../../dto/GenApi.iNotPaie.Dto/DeclarationOethDto";
import { Prop } from "vue-property-decorator";
import ModalSaisieOeth from "./../modalSaisieOeth/modalSaisieOeth";
import ModalRapportOeth from "./../modalRapportOeth/modalRapportOeth";
import $ from "jquery";
import * as moment from "moment";
import ModalSaisieEffectifOeth from "../modalSaisieEffectifOeth/modalSaisieEffectifOeth";
import { ExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { Parametres, ParametresInstance } from "../../Controls/Parameters";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EtatDeclarationOeth } from "../../../dto/GenApi.iNotPaie.Dto/EtatDeclarationOeth";

interface rapportObject {
	declaration: DeclarationOethDto,
	readOnly: boolean
}

@Component({
	components: {
		ModalSaisieOeth: require("./../modalSaisieOeth/modalSaisieOeth.vue.html"),
		modalSaisieEffectifOeth: require("./../modalSaisieEffectifOeth/modalSaisieEffectifOeth.vue.html"),
		ModalRapportOeth: require("./../modalRapportOeth/modalRapportOeth.vue.html")
	}
})
export default class TableOeth extends VueBase {
	@Prop()
	public filteredListOeth: DeclarationOethDto[] = [];

	@Prop()
	public lastExerciceClosed!: ExerciceDto;

	public modalSaisieOeth?: ModalSaisieOeth = undefined;
	public modalSaisieEffectifOeth?: ModalSaisieEffectifOeth = undefined;
	public modalRapportOeth?: ModalRapportOeth = undefined;
	public currentOrderColumn = "Id";
	public orderingDesc = true;

	public openModalSaisieOETHBack(item: rapportObject): void {
		this.openModalSaisieOETH(item.declaration, item.readOnly);
	}

	public openModalSaisieOETH(item: DeclarationOethDto, onlyRead = false): void {
    	if (this.modalSaisieOeth == undefined) {
			this.modalSaisieOeth = this.$refs.modalSaisieOeth as ModalSaisieOeth;
		}

    	if (this.modalSaisieOeth != undefined) {
			this.modalSaisieOeth.init(item, onlyRead);
		}

    	$("#modalSaisieOeth").modal({
    		backdrop: "static"
    	});
	}

	public openModalSaisieEffectifOETH(item: DeclarationOethDto): void {
    	if (this.modalSaisieEffectifOeth == undefined) {
			this.modalSaisieEffectifOeth = this.$refs.modalSaisieEffectifOeth as ModalSaisieEffectifOeth;
		}

    	if (this.modalSaisieEffectifOeth != undefined) {
			this.modalSaisieEffectifOeth.init(item);
		}

    	$("#modalSaisieEffectifOeth").modal({
    		backdrop: "static"
    	});
	}

	public displayMonthName(monthNumber: number): string {
    	return (monthNumber) ? this.ucFirst(moment.utc().set("month", monthNumber - 1).format("MMMM")) : "-";
	}

	public displayYear(year: number): string | number {
    	return (year) || "-";
	}

	private ucFirst(string): string {
    	return string.charAt(0).toUpperCase() + string.slice(1);
	}

	public openModalRapportOETH(item: rapportObject): void {
    	if (this.modalRapportOeth == undefined) {
			this.modalRapportOeth = this.$refs.modalRapportOeth as ModalRapportOeth;
		}

    	if (this.modalRapportOeth != undefined) {
			this.modalRapportOeth.init(item);
		}

    	$("#modalRapportOeth").modal({
    		backdrop: "static"
    	});
	}

	public getClassOfOrder(columnName: string, desc: any): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	private doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;

    	if (this.filteredListOeth != undefined) {
    		this.filteredListOeth = this.filteredListOeth.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public isLastExerciceClosed(year: number): boolean {
    	return (year == (this.lastExerciceClosed.Annee - 1));
	}

	/**
	 * Si on est à M+2 de la date de rattachement de la déclaration Oeth, on ne peut plus la modifier.
	 * On se base donc sur le dernier exercice clôturé : on compare donc d'un mois à l'autre (strictement inférieur).
	 * @param {DeclarationOethDto} declaration
	 * @returns {boolean}
	 */
	public allowEditing(declaration: DeclarationOethDto): boolean
	{
		if (declaration.Etat != EtatDeclarationOeth.IntegreeDsn) {
			return true;
		}

		if (declaration.AnneeDsnMetadata != undefined && declaration.MoisDsnMetadata != undefined) {
			// en js, les mois commencent à 0 (janvier). On fait donc un -1 pour avoir le bon mois
			// un dépassement fait passer à l'année suivante (12 (decembre) 2023 + 1 => 0 (janvier) 2024)
			const exerciceClotureDate = new Date(this.lastExerciceClosed.Annee, this.lastExerciceClosed.Mois - 1, 1);			
			const metadataDate = new Date(declaration.AnneeDsnMetadata, declaration.MoisDsnMetadata - 1, 1);

			if (metadataDate < exerciceClotureDate) {
                return false;
            }
		}

		return true;
	}

	public refresh(): void {
    	this.$emit("refresh");
	}

	public refreshDsn(): void {
    	this.$emit("refreshDsn");
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/tableOeth/tableOeth.ts